import {ChangeDetectionStrategy,Component,inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NgOptimizedImage} from '@angular/common';
import {DomSanitizer,Meta,Title} from '@angular/platform-browser';
import {AppService} from '../app.service';
import {FACEBOOK_SDK} from '../common/facebook/facebook.tokens';
import {X_WIDGETS} from '../common/x/x.tokens';

@Component({
	selector:'app-medicina-biorreguladora',
	imports:[MatButtonModule,MatCardModule,MatIconModule,MatMenuModule,MatTooltipModule,NgOptimizedImage],
	templateUrl:'./medicina-biorreguladora.html',
	styleUrl:'./medicina-biorreguladora.scss',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class MedicinaBiorreguladoraComponent{
	private readonly meta=inject(Meta);
	private readonly titleService=inject(Title);
	readonly appService=inject(AppService);
	private readonly domSanitizer=inject(DomSanitizer);
	private readonly loadFacebook=inject(FACEBOOK_SDK);
	private readonly loadXWidgets=inject(X_WIDGETS);
	// Built from environment.siteUrl rather than document.location so the anchors are correct
	// in the prerendered HTML, where there is no browser location to read.
	readonly shareUrl=this.appService.absoluteUrl('/medicina-biorreguladora');
	readonly shareFacebookUrl=this.domSanitizer.bypassSecurityTrustResourceUrl(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareUrl)}&src=sdkpreparse`);
	readonly shareXUrl=`https://x.com/intent/post?url=${encodeURIComponent(this.shareUrl)}`;
	readonly title=$localize`:medicina title:L&O Medical - Medicina Biorreguladora`;

	constructor(){
		const description=$localize`:medicina description:La situación mundial ha cambiado muchas cosas, entre ellas la medicina. Ahora la medicina debe convertirse en una gestión preventiva, ver al paciente de una manera integral, cuidar de los efectos secundarios de los medicamentos, reforzar el sistema inmunológico.`;
		this.titleService.setTitle(this.title);
		this.meta.updateTag({content:this.title},'property="og:title"');
		this.meta.updateTag({content:description},'name="description"');
		this.meta.updateTag({content:description},'property="og:description"');
		this.meta.updateTag({content:$localize`:medicina keywords:lyo, l&o, medical, medicina, biorreguladora, sueroterapia, autosanguis, bogotá, soacha, ibagué`},'name="keywords"');
		this.meta.updateTag({content:this.appService.ogImageUrl},'property="og:image"');
	}

	async loadShareWidgets():Promise<void>{
		const [facebook,x]=await Promise.all([this.loadFacebook(),this.loadXWidgets()]);
		x?.widgets.load();
		facebook?.XFBML.parse();
	}
}
